import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import type { PolicyResponse } from '@http/queries/useCreatePolicy';

export type { PolicyResponse } from '@http/queries/useCreatePolicy';

/** A single custom policy by id (`GET /policies?id=…`). */
function policyQueryOptions(id: number | null) {
  return queryOptions({
    queryKey: [api.policies, id],
    queryFn: () => fetchWrapper.get<PolicyResponse>(api.policies, { id }),
    // Always refetch on mount so the edit form opens with the latest data.
    refetchOnMount: 'always',
  });
}

export function useFetchPolicy(id: number | null) {
  return useQuery({
    ...policyQueryOptions(id),
    enabled: id !== null && Number.isInteger(id) && id > 0,
  });
}

/** Required page data: loading and initial errors belong to the route boundaries. */
export function useSuspensePolicy(id: number) {
  return useSuspenseQuery({
    ...policyQueryOptions(id),
    meta: { handlesInitialError: true },
  });
}
